import { motion } from "motion/react"
import { cn } from "@/lib/utils"

type Props = {
  title?: string
  name: string
  className?: string
  withTopBorder?: boolean
  animateKey?: string
}

export function SubjectCaption({
  title,
  name,
  className,
  withTopBorder = false,
  animateKey,
}: Props) {
  return (
    <motion.div
      key={animateKey}
      initial={animateKey ? { opacity: 0, y: 6 } : false}
      animate={animateKey ? { opacity: 1, y: 0 } : undefined}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
      className={cn(
        "flex flex-col items-center text-center",
        withTopBorder && "border-white/10 border-t pt-5",
        className
      )}
    >
      {title && (
        <p className="font-mono text-[10px] text-label uppercase tracking-[0.4em]">
          {title}
        </p>
      )}
      <h3
        className={cn(
          "font-medium font-mono text-2xl text-white uppercase tracking-tight",
          title && "mt-3"
        )}
      >
        {name}
      </h3>
    </motion.div>
  )
}
